{
  "blocks": [
    {
      "id": "proc-egg-retrieval",
      "kind": "procedure",
      "tags": ["ivf", "egg-freezing", "her", "during-cycle"],
      "title": "Egg Retrieval",
      "subtitle": "Short surgical procedure to collect mature eggs from the ovaries after stimulation",
      "body": {
        "procedureName": "Egg Retrieval",
        "category": "retrieval",
        "description": "A short surgical procedure to collect mature eggs from the ovaries after stimulation. Performed under light sedation.",
        "howItWorks": "Under IV sedation (you'll be asleep), the doctor uses a transvaginal ultrasound probe with a thin needle attached. The needle passes through the vaginal wall into each ovarian follicle, and the fluid containing the egg is aspirated. Each follicle takes about 30 seconds. The eggs are immediately identified and counted by the embryology team in the adjacent lab.",
        "duration": "15-30 minutes",
        "anesthesia": "sedation",
        "painAndComfort": [
          "You should be asleep during retrieval; cramping, bloating, and light spotting afterward are common."
        ],
        "recoveryTime": "1-2 hours in recovery, rest for remainder of the day",
        "costRange": {
          "low": 1500,
          "high": 5000
        },
        "currency": "USD",
        "whatToExpect": [
          "Arrive 1 hour before for IV and prep",
          "You'll be asleep during the procedure",
          "Wake up in recovery, most feel groggy but comfortable",
          "Mild to moderate cramping and bloating afterward",
          "Light spotting is normal",
          "Know your egg count before leaving the clinic"
        ],
        "results": [
          {
            "label": "Egg count",
            "detail": "Most clinics can tell you the number of eggs retrieved before you leave or later the same day."
          },
          {
            "label": "Maturity",
            "detail": "If you are doing IVF or egg freezing, the mature egg count may be confirmed by the lab after the eggs are assessed."
          },
          {
            "label": "Next update",
            "detail": "For IVF, fertilization results are usually shared the next morning. For egg freezing, the clinic may confirm how many mature eggs were frozen."
          }
        ],
        "prepInstructions": [
          "Your clinic tells you when to stop eating and drinking before the sedation; follow their timing exactly",
          "Arrange for someone to drive you home (required)",
          "Wear comfortable loose-fitting clothing",
          "If your clinic asks, come without jewelry, make-up or nail polish",
          "Take the prescribed trigger shot exactly when your clinic tells you; this is often about 36 hours before retrieval, but protocols vary"
        ],
        "risks": [
          "Mild to moderate pelvic pain and cramping",
          "Bloating (resolves in 1-2 weeks)",
          "Light vaginal bleeding",
          "Very rare: infection or ovarian torsion"
        ],
        "forWhom": "her",
        "frBody": {
          "procedureName": "Ponction ovocytaire",
          "description": "Court geste chirurgical permettant de prélever les ovocytes matures dans les ovaires après stimulation. Réalisé sous sédation légère.",
          "howItWorks": "Sous sédation intraveineuse (vous êtes endormie), le médecin utilise une sonde d'échographie endovaginale équipée d'une fine aiguille. L'aiguille traverse la paroi vaginale pour atteindre chaque follicule ovarien, et le liquide contenant l'ovocyte est aspiré. Chaque follicule prend environ 30 secondes. Les ovocytes sont immédiatement identifiés et comptés par l'équipe d'embryologie dans le laboratoire adjacent.",
          "duration": "15 à 30 minutes",
          "recoveryTime": "1 à 2 heures en salle de réveil, repos pour le reste de la journée",
          "whatToExpect": [
            "Arrivée 1 heure avant pour la pose de la perfusion et la préparation",
            "Vous serez endormie pendant le geste",
            "Réveil en salle de réveil : la plupart des patientes se sentent encore somnolentes mais confortables",
            "Crampes et ballonnements légers à modérés ensuite",
            "Des saignements légers sont normaux",
            "Vous connaîtrez votre nombre d'ovocytes recueillis avant de quitter la clinique"
          ],
          "results": [
            {
              "label": "Nombre d'ovocytes",
              "detail": "La plupart des centres peuvent vous donner le nombre d'ovocytes recueillis avant votre départ ou plus tard le jour même."
            },
            {
              "label": "Maturité",
              "detail": "En FIV ou congélation ovocytaire, le nombre d'ovocytes matures peut être confirmé par le laboratoire après évaluation."
            },
            {
              "label": "Prochaine information",
              "detail": "En FIV, les résultats de fécondation sont souvent communiqués le lendemain matin. En congélation ovocytaire, le centre peut confirmer combien d'ovocytes matures ont été congelés."
            }
          ],
          "prepInstructions": [
            "Votre clinique vous indique quand arrêter de manger et de boire avant la sédation ; respectez exactement cet horaire",
            "Prévoyez quelqu'un pour vous raccompagner (obligatoire)",
            "Portez des vêtements amples et confortables",
            "Si votre clinique le demande, venez sans bijoux, maquillage ni vernis à ongles",
            "Prenez votre déclencheur (trigger) exactement au moment indiqué par votre clinique; c'est souvent environ 36 heures avant la ponction, mais les protocoles varient"
          ],
          "risks": [
            "Douleurs pelviennes et crampes légères à modérées",
            "Ballonnements (disparaissent en 1 à 2 semaines)",
            "Saignements vaginaux légers",
            "Très rare : infection ou torsion ovarienne"
          ]
        }
      },
      "sources": [
        {
          "title": "ESHRE guideline: ovarian stimulation for IVF/ICSI",
          "authors": "ESHRE Guideline Group on Ovarian Stimulation",
          "journal": "Human Reproduction Open",
          "year": 2020,
          "url": "https://academic.oup.com/hropen/article/2020/2/hoaa009/5826933",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
